/* eslint-disable no-useless-computed-key */
import React, { useEffect, useState } from "react";
import { 
  FiTrendingUp, 
  FiRefreshCw,
  FiPlus,
  FiSearch,
  FiFilter,
  FiGrid,
  FiList,
  FiCheckCircle,
  FiXCircle,
  FiClock,
  FiDollarSign,
  FiTag,
  FiUsers,
  FiBarChart2,
  FiAward,
  FiStar,
  FiCalendar,
  FiEye,
  FiEdit2,
  FiTrash2,
  FiMoreVertical,
  FiSettings,
  FiBell,
  FiAlertCircle
} from "react-icons/fi";
import { 
  MdOutlineCampaign, 
  MdOutlineAdsClick,
  MdOutlineTrendingUp,
  MdOutlineMonetizationOn,
  MdOutlineVerified,
  MdOutlineCancel,
  MdOutlinePending,
  MdOutlineCheckCircle,
  MdOutlineDelete,
  MdOutlineEdit,
  MdOutlineVisibility,
  MdOutlineMoreVert,
  MdOutlineAdd,
  MdOutlineRefresh
} from "react-icons/md";
import { IoMegaphoneOutline, IoRocketOutline, IoSparklesOutline } from "react-icons/io5";
import Card from "../../components/Card/Card";
import card1icon from "../../public/images/card1.svg";
import card2icon from "../../public/images/card2.svg";
import card4icon from "../../public/images/card4.svg";
import Button from "../../components/Button/Button";
import AddsTable from "./Tables/AddsTable";
import PromotationTable from "./Tables/PromotationTable";
import CreateAdsModal from "./Modal/CreateAdsModal";
import EditAdsModal from "./Modal/EditAdsModal";
import CreatePromoModal from "./Modal/CreatePromoModal ";
import { useDispatch, useSelector } from "react-redux";
import {
  bannerStatusUpdate,
  getBannerCount,
  boostListAdmin,
  boostStatusUpdate,
  getBannerList,
  getPlanList,
  saveBannerPlan,
  disableEnablePlan,
  savePlans,
  advertisementList,
  actionByAdminOnPromotions,
  saveNewAdvertisementFromAdminSide,
  advertisementStatusUpdate,
} from "../../Redux/bannerSlice";
import ViewAds from "./Modal/ViewAds";
import ViewBanner from "./Modal/ViewBanner";
import Plantable from "./Tables/PlanTable";
import EditPlan from "./Modal/EditPlan";
import AdvertisementTable from "./Tables/AdvertisementTable";
import ViewAdvertisement from "./Modal/ViewAdvertisement";
import ConfirmToggleModal from "./Modal/ConfirmToggleModal";
import { toast } from "react-toastify";
import Loader from "../../components/Loader/Loader";
import CreateNewAdvertisement from "./Modal/CreateNewAdvertisement";

const adsFeilds = {
  title: "",
  period: "",
  mediaType: "image",
  imageUrl: "",
  videoUrl: "",
  placeAt: "main",
  startDate: "",
  endDate: "",
};
const PromoFeilds = { boostName: "", boostPeriod: "", boostCharge: "" };

const formatNumber = (num) => {
  if (num === null || num === undefined) return "0";
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + "M";
  } else if (num >= 1000) {
    return (num / 1000).toFixed(1) + "K";
  }
  return num.toString();
};

const AdsAndPromotation = () => {
  const dispatch = useDispatch();
  const selector = useSelector((state) => state);
  const {
    banner: {
      boostList = [],
      bannerList = [],
      totalBanner = null,
      totalBoostList = null,
      bannerCount = null,
      planList = [],
      advertisements = [],
      advertisementTotal = null,
    },
  } = selector ? selector : {};
  const [activeTab, setActiveTab] = useState("AdsPromotionManagement");
  const [isCreateAddModal, setIsCreateModal] = useState(false);
  const [isEditAdsmodal, setIsEditAdsModal] = useState(false);
  const [inputsData, setInputsData] = useState(adsFeilds);
  const [promoInputsData, setPromoInputsData] = useState(PromoFeilds);
  const [editAdsData, setEditAdsData] = useState(null);
  const [planFilter, setPlanFilter] = useState({ type: "" });
  const [confirmModalState, setConfirmModalState] = useState({
    isOpen: false,
    status: "",
    _id: "",
    type: "",
  });

  const adsTableHeader = [
    { label: "#", sortKey: null },
    { label: "Promotion Name", sortKey: "title" },
    { label: "User Name", sortKey: "user.fullName" },
    { label: "Status", sortKey: "status" },
    { label: "Place At", sortKey: "placeAt" },
    { label: "Active Period", sortKey: null },
    { label: "Charges", sortKey: "planId.price" },
    { label: "Action", sortKey: null },
  ];
  const promationTableHeader = [
    { label: "#", sortKey: null },
    { label: "Title", sortKey: "courseId.title" },
    { label: "Status", sortKey: "status" },
    { label: "Usage Limit", sortKey: "planId.durationInDays" },
    { label: "Charges", sortKey: "planId.price" },
    { label: "Action", sortKey: null },
  ];
  const planTableHeader = [
    { label: "#", sortKey: null },
    { label: "Title", sortKey: "title" },
    { label: "Price", sortKey: "price" },
    { label: "Duration", sortKey: "durationInDays" },
    { label: "Type", sortKey: "type" },
    { label: "CreatedAt", sortKey: "createdAt" },
    { label: "Action", sortKey: null },
  ];

  const advertisementTableHeader = [
    { label: "#", sortKey: null },
    { label: "Promotion Name", sortKey: "title" },
    { label: "User Name", sortKey: "user.fullName" },
    { label: "Status", sortKey: "status" },
    { label: "Place At", sortKey: null },
    { label: "Active Period", sortKey: null },
    { label: "Charges", sortKey: "planId.price" },
    { label: "Action", sortKey: null },
  ];

  const [isViewModal, setIsViewModal] = useState(false);
  const [clickedData, setIsClickedData] = useState(null);
  const [isBannerViewModal, setIsBannerViewModal] = useState(false);
  const [isAdvertisementViewModal, setIsAdvertisementViewModal] =
    useState(false);
  const [isEditPlanModal, setIsEditPlanModal] = useState(false);
  const [editPlanData, setEditPlanData] = useState({});
  const [isCreateBoostPlanModal, setIsCreateBoostPlanModal] = useState(false);
  const [isActionLoading, setIsActionLoading] = useState(false);

  const initFilter = {
    keyWord: "",
    pageNo: 1,
    size: 8,
    sortBy: "createdAt",
    sortOrder: "desc",
    fromDate: "",
    toDate: "",
  };

  const [filter1, setFilter1] = useState({
    ...initFilter,
    status: "",
  });

  const [filter2, setFilter2] = useState({
    ...initFilter,
    status: "",
  });

  const [filter3, setFilter3] = useState({
    ...initFilter,
    pageNo: 1,
    size: 10,
  });

  const [filter4, setFilter4] = useState({
    ...initFilter,
  });

  const [newAdvertisement, setNewAdvertisement] = useState({
    isOpen: false,
    data: null,
  });

  const handleSort1 = (key) => {
    setFilter1((prev) => {
      const isSameKey = prev.sortBy === key;
      return {
        ...prev,
        sortBy: key,
        sortOrder: isSameKey && prev.sortOrder === "asc" ? "desc" : "asc",
        pageNo: 1
      };
    });
  };

  const handleSort2 = (key) => {
    setFilter2((prev) => {
      const isSameKey = prev.sortBy === key;
      return {
        ...prev,
        sortBy: key,
        sortOrder: isSameKey && prev.sortOrder === "asc" ? "desc" : "asc",
        pageNo: 1
      };
    });
  };

  const handleSort3 = (key) => {
    setFilter3((prev) => {
      const isSameKey = prev.sortBy === key;
      return {
        ...prev,
        sortBy: key,
        sortOrder: isSameKey && prev.sortOrder === "asc" ? "desc" : "asc",
        pageNo: 1
      };
    });
  };

  const handleSort4 = (key) => {
    setFilter4((prev) => {
      const isSameKey = prev.sortBy === key;
      return {
        ...prev,
        sortBy: key,
        sortOrder: isSameKey && prev.sortOrder === "asc" ? "desc" : "asc",
        pageNo: 1
      };
    });
  };

  useEffect(() => {
    dispatch(getBannerCount({}));
  }, [dispatch]);

  useEffect(() => {
    dispatch(getBannerList(filter1));
  }, [dispatch, filter1]);

  useEffect(() => {
    dispatch(boostListAdmin(filter2));
  }, [dispatch, filter2]);

  useEffect(() => {
    const { type } = planFilter;
    dispatch(getPlanList({ type, ...filter3 }));
  }, [planFilter, dispatch, filter3]);

  useEffect(() => {
    dispatch(advertisementList(filter4));
  }, [dispatch, filter4]);

  const handleAdsView = (data) => {
    setIsViewModal(true);
    setIsClickedData(data);
  };
  const handleBannerView = (data) => {
    setIsBannerViewModal(true);
    setIsClickedData(data);
  };

  const handleAdvertisementView = (data) => {
    setIsAdvertisementViewModal(true);
    setIsClickedData(data);
  };
  const handleCreateAds = () => {
    setIsCreateModal(!isCreateAddModal);
  };
  const toggleAdsCreateModal = () => {
    setIsCreateModal(!isCreateAddModal);
    setInputsData(adsFeilds);
  };

  const handleAdsCreateOnChnage = (e) => {
    const { name, value } = e.target;
    setInputsData({ ...inputsData, [name]: value });
  };

  const submitCreateAds = (e) => {
    e.preventDefault();
    const apiPayload = {
      title: inputsData.title,
      period: inputsData.period,
      mediaType: inputsData.mediaType || "image",
      imageUrl: inputsData.imageUrl,
      videoUrl: inputsData.mediaType === "video" ? inputsData?.videoUrl : null,
      placeAt: inputsData.placeAt || "main",
      startDate: inputsData.startDate,
      endDate: inputsData.endDate,
    };

    if (inputsData._id) {
      apiPayload._id = inputsData._id;
    }

    dispatch(saveBannerPlan({ Payload: apiPayload, forReferesh: filter1 }));
    setIsCreateModal(false);
    setInputsData(adsFeilds);
  };

  const handleEditAds = (data) => {
    setIsEditAdsModal(!isEditAdsmodal);
    setEditAdsData(data);
  };
  const toggleEditAdsData = () => {
    setIsEditAdsModal(!isEditAdsmodal);
  };
  const handleAdsEditOnChange = (e) => {
    const { name, value } = e.target;
    setEditAdsData({ ...editAdsData, [name]: value });
  };

  const handleCreatePromoCreateOnChange = (e) => {
    const { name, value } = e.target;
    setPromoInputsData({ ...promoInputsData, [name]: value });
  };
  const togglePromoCreateModal = () => {
    setIsCreateBoostPlanModal(false);
  };

  const toggleModal = (action) => {
    switch (action) {
      case "VIEW":
        setIsViewModal(false);
        break;
      case "VIEW_BANNER":
        setIsBannerViewModal(false);
        break;
      case "VIEW_ADVERTISEMENT":
        setIsAdvertisementViewModal(false);
        break;
      default:
        setIsClickedData(null);
    }
  };

  const handleStatus = (action, data) => {
    switch (action) {
      case "approved":
        let togglePayload = {
          id: data?._id,
          stauts: "approved",
        };
        dispatch(
          bannerStatusUpdate({ payload: togglePayload, filter: filter1 }),
        );
        break;
      case "rejected":
        let togglePayload2 = {
          id: data?._id,
          stauts: "rejected",
        };
        dispatch(
          bannerStatusUpdate({ payload: togglePayload2, filter: filter1 }),
        );
        break;
      case "delete":
        let togglePayload3 = {
          id: data?._id,
          stauts: "delete",
        };
        dispatch(
          bannerStatusUpdate({ payload: togglePayload3, filter: filter1 }),
        );
        break;
      default:
        alert("wrong action");
    }
  };

  const handlePageClick = (data) => {
    setFilter1((p) => ({
      ...p,
      ["pageNo"]: +data.selected + 1,
    }));
  };

  const handlePageClick4 = (data) => {
    setFilter4((p) => ({
      ...p,
      ["pageNo"]: +data.selected + 1,
    }));
  };

  const handlePageClick2 = (data) => {
    setFilter2((p) => ({
      ...p,
      ["pageNo"]: +data.selected + 1,
    }));
  };

  const handleSearch = (e) => {
    setFilter1((p) => ({
      ...p,
      ["keyWord"]: e.target.value,
    }));
  };

  const handleSearch4 = (e) => {
    setFilter4((p) => ({
      ...p,
      ["keyWord"]: e.target.value,
    }));
  };

  const handleSearch2 = (e) => {
    setFilter2((p) => ({
      ...p,
      ["keyWord"]: e.target.value,
    }));
  };

  const handlePlanSearch = (e) => {
    setFilter3((p) => ({
      ...p,
      ["keyWord"]: e.target.value,
    }));
  };

  const handleCreateBoostPlan = () => {
    setIsCreateBoostPlanModal(true);
  };

  const handleBoostSubmit = () => {
    const apiPayload = {
      title: promoInputsData.boostName,
      price: promoInputsData.boostCharge,
      durationInDays: promoInputsData.boostPeriod,
      type: "boost",
    };
    dispatch(saveBannerPlan({ Payload: apiPayload, forReferesh: filter1 }));
    setIsCreateBoostPlanModal(false);
    setPromoInputsData(null);
  };

  const handleStatusBoost = (action, data) => {
    switch (action) {
      case "approved":
        let togglePayload = {
          id: data?._id,
          stauts: "approved",
        };
        dispatch(
          boostStatusUpdate({ Payload: togglePayload, forReferesh: filter1 }),
        );
        break;
      case "rejected":
        let togglePayload2 = {
          id: data?._id,
          stauts: "rejected",
        };
        dispatch(
          boostStatusUpdate({ Payload: togglePayload2, forReferesh: filter1 }),
        );
        break;
      default:
        alert("wrong action");
    }
  };

  const editAction = (data) => {
    if (data) {
      setIsEditPlanModal(true);
      setEditPlanData(data);
    } else {
      setIsEditPlanModal(true);
      setEditPlanData({
        title: "",
        price: "",
        type: "banner",
        durationInDays: "",
      });
    }
  };

  const handleDelete = (id) => {
    dispatch(disableEnablePlan({ id }));
  };

  const togglePlanEditModal = () => {
    setIsEditPlanModal(false);
    setEditPlanData(null);
  };

  const handlePlanEditChange = (e) => {
    const { name, value } = e.target;
    setEditPlanData({
      ...editPlanData,
      [name]: value,
    });
  };

  const handleEditPlanSubmit = (e) => {
    e.preventDefault();
    let apiPayload = {
      _id: editPlanData?._id,
      title: editPlanData?.title,
      price: editPlanData?.price,
      type: editPlanData?.type,
      durationInDays: editPlanData?.durationInDays,
    };

    dispatch(savePlans({ Payload: apiPayload, forReferesh: filter1 }));
    setIsEditPlanModal(false);
  };

  const handleAddsFilter = (name, value) => {
    // Implementation as needed
  };

  const openConfirmModalForPromotions = (data) => {
    setConfirmModalState({
      isOpen: true,
      ...data,
    });
  };

  const closeConfirmModalForPromotions = () => {
    setConfirmModalState({
      isOpen: false,
    });
  };

  const handleConfirmToggle = async () => {
    try {
      setIsActionLoading(true);
      const response = await dispatch(
        actionByAdminOnPromotions({
          _id: confirmModalState?._id,
          status:
            confirmModalState?.status === "approved"
              ? "disable_by_admin"
              : "approved",
          type: confirmModalState?.type,
        }),
      );
      const type = confirmModalState?.type;

      if (response?.payload?.code === 200) {
        toast.success(
          response?.payload?.message || "Status updated successfully",
        );

        if (type === "banner") {
          dispatch(getBannerList(filter1));
        } else if (type === "boost") {
          dispatch(boostListAdmin(filter2));
        } else {
          dispatch(advertisementList(filter4));
        }
      } else {
        toast.error(response?.payload?.message || "Failed to update status.");
      }
    } catch (error) {
      console.error(error);
      toast.error(
        error?.message || "Oops! Something went wrong. Please try again.",
      );
    } finally {
      setIsActionLoading(false);
      closeConfirmModalForPromotions();
    }
  };

  const handleNewAdvertisementModal = (type = "open", data = {}) => {
    if (type === "open") {
      setNewAdvertisement({
        isOpen: true,
        data: {
          ...data,
          mediaType: data?.mediaType || "image",
          imageUrl: data?.imageUrl || "",
          videoUrl: data?.videoUrl || "",
        },
      });
    } else {
      setNewAdvertisement({
        isOpen: false,
        data: {},
      });
    }
  };

  const handleNewAdvertisementSubmission = async (e) => {
    try {
      e.preventDefault();
      setIsActionLoading(true);
      const isVideo = newAdvertisement.data.mediaType === "video";
      const apiPayload = {
        title: newAdvertisement.data.title,
        period: newAdvertisement.data.period,
        mediaType: newAdvertisement.data.mediaType || "image",
        imageUrl: newAdvertisement.data.imageUrl,
        videoUrl: isVideo ? (newAdvertisement.data?.videoUrl || null) : null,
        startDate: newAdvertisement.data.startDate,
        endDate: newAdvertisement.data.endDate,
        positions: newAdvertisement.data.positions,
        placementConfig: newAdvertisement.data.placementConfig,
      };

      if (newAdvertisement.data?._id) {
        apiPayload._id = newAdvertisement.data._id;
      }

      const response = await dispatch(
        saveNewAdvertisementFromAdminSide({ Payload: apiPayload }),
      ).unwrap();

      if (response?.code === 200) {
        toast.success(response?.message || "Advertisement saved successfully");
        handleNewAdvertisementModal("close");
        dispatch(advertisementList(filter4));
      } else {
        toast.error(response?.message || "Failed to save advertisement");
      }
    } catch (error) {
      console.error(error);
      toast.error(
        error?.message || "Oops! Something went wrong. Please try again.",
      );
    } finally {
      setIsActionLoading(false);
    }
  };

  const handleAdvertisementStatus = (action, data) => {
    switch (action) {
      case "approved":
        let togglePayload = {
          id: data?._id,
          stauts: "approved",
        };
        dispatch(
          advertisementStatusUpdate({
            payload: togglePayload,
            filter: filter4,
          }),
        );
        break;
      case "rejected":
        let togglePayload2 = {
          id: data?._id,
          stauts: "rejected",
        };
        dispatch(
          advertisementStatusUpdate({
            payload: togglePayload2,
            filter: filter4,
          }),
        );
        break;
      case "delete":
        let togglePayload3 = {
          id: data?._id,
          stauts: "delete",
        };
        dispatch(
          advertisementStatusUpdate({
            payload: togglePayload3,
            filter: filter4,
          }),
        );
        break;
      default:
        alert("wrong action");
    }
  };

  const handleUpdateBannerModal = (data) => {
    setIsCreateModal(true);
    setInputsData({
      ...data,
      mediaType: data?.mediaType || "image",
      videoUrl: data?.videoUrl || "",
      imageUrl: data?.imageUrl || "",
    });
  };

  // Stats cards data
  const statsCards = [
    {
      title: "Ads & Promotions",
      count: bannerCount?.totalBanner || 0,
      icon: MdOutlineCampaign,
      color: "from-blue-500 to-blue-600",
      subtitle: "Total Ads"
    },
    {
      title: "Boost Plans",
      count: bannerCount?.totalBoost || 0,
      icon: IoRocketOutline,
      color: "from-emerald-500 to-emerald-600",
      subtitle: "Total created"
    },
    {
      title: "Total Earnings",
      count: bannerCount?.totalAmount || 0,
      icon: MdOutlineMonetizationOn,
      color: "from-amber-500 to-amber-600",
      subtitle: "Views"
    }
  ];

  // Tab configuration with icons
  const tabs = [
    { id: "AdsPromotionManagement", label: "Banner Management", icon: FiGrid },
    { id: "PromotionalCodesDiscounts", label: "Boost Management", icon: FiAward },
    { id: "Advertisement", label: "Advertisement Management", icon: FiBarChart2 },
    { id: "plan", label: "Plan Management", icon: FiSettings }
  ];

  return (
    <div className="min-h-screen bg-gray-50/80">
      <Loader loading={isActionLoading} />

      {/* Header Banner */}
      <div className="bg-gradient-to-r from-[#855DF6] via-[#7B5CF6] to-[#715EFE] shadow-lg relative overflow-hidden">
        <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -mr-20 -mt-20 animate-pulse"></div>
        <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/5 rounded-full -ml-12 -mb-12 animate-pulse"></div>
        <div className="absolute top-1/2 left-1/2 w-96 h-96 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2 animate-pulse"></div>
        
        <div className="relative z-10 px-4 md:px-7 py-6 md:py-8">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div className="flex items-center gap-3">
              <div className="p-2.5 bg-white/20 rounded-xl backdrop-blur-sm shadow-lg">
                <IoMegaphoneOutline className="w-5 h-5 text-white md:w-6 md:h-6" />
              </div>
              <div>
                <h2 className="text-xl font-bold text-white md:text-2xl dahboardFont tracking-tight">
                  Advertising & Promotion Management
                </h2>
                <p className="text-sm text-white/70 hidden sm:block">
                  Manage campaigns, boosts, and advertisements
                </p>
              </div>
            </div>
            {/* <div className="flex items-center gap-2">
              <div className="flex items-center gap-2 px-3 py-1.5 bg-white/20 rounded-full backdrop-blur-sm">
                <FiRefreshCw className="w-3.5 h-3.5 text-white/70" />
                <span className="text-xs text-white/80">
                  {new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                </span>
              </div>
            </div> */}
          </div>

          {/* Stats Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mt-5 md:gap-4">
            {statsCards.map((card, index) => (
              <div 
                key={index}
                className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4 border border-white/20 hover:bg-white/20 transition-all duration-300 group"
              >
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-lg font-bold text-white uppercase md:text-lg">
                      {card.title}
                    </p>
                    <p className="text-xl font-bold text-white md:text-2xl mt-0.5">
                      {formatNumber(card.count)}
                    </p>
                    {card.subtitle && (
                      <p className="text-[14px] text-white/40 hidden sm:block">
                        {card.subtitle}
                      </p>
                    )}
                  </div>
                  <div className={`p-2 rounded-xl bg-gradient-to-br ${card.color} bg-opacity-30 shadow-inner`}>
                    <card.icon className="w-4 h-4 text-white md:w-5 md:h-5" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Main Content */}
      <section className="px-3 py-4 -mt-4 md:px-6 lg:px-10 md:py-6">
        <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100/80 overflow-hidden">
          {/* Tab Navigation */}
          <div className="flex flex-wrap border-b border-gray-100 bg-gray-50/50">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                className={`
                  flex items-center gap-2 px-4 py-3 text-sm font-medium transition-all duration-200
                  ${activeTab === tab.id 
                    ? "text-[#715EFE] border-b-2 border-[#715EFE] bg-white" 
                    : "text-gray-500 hover:text-gray-700 hover:bg-gray-100/50"
                  }
                `}
                onClick={() => setActiveTab(tab.id)}
              >
                <tab.icon className="w-4 h-4" />
                <span>{tab.label}</span>
              </button>
            ))}
          </div>

          {/* Content */}
          <div className="p-3 md:p-4">
            {activeTab === "AdsPromotionManagement" && (
              <AddsTable
                handleFilter={handleAddsFilter}
                filter={filter1}
                setFilter={setFilter1}
                TableName={`Platform Wide Banner Promotions`}
                TableHeader={adsTableHeader}
                TableData={bannerList}
                handleCreateAds={handleCreateAds}
                editAction={handleEditAds}
                viewAction={handleBannerView}
                handleStatus={handleStatus}
                handlePageClick={handlePageClick}
                total={totalBanner}
                handleSearch={handleSearch}
                formatNumber={formatNumber}
                openConfirmModalForPromotions={openConfirmModalForPromotions}
                handleUpdateBannerModal={handleUpdateBannerModal}
                currentSortKey={filter1.sortBy}
                currentSortOrder={filter1.sortOrder}
                onSort={handleSort1}
              />
            )}
            {activeTab === "PromotionalCodesDiscounts" && (
              <PromotationTable
                filter={filter2}
                setFilter={setFilter2}
                TableName="Platform Wide Boost Promotions"
                TableHeader={promationTableHeader}
                TableData={boostList}
                handlePageClick={handlePageClick2}
                total={totalBoostList}
                handleCreateBoostPlan={handleCreateBoostPlan}
                viewAction={handleAdsView}
                handleSearch2={handleSearch2}
                handleStatus={handleStatusBoost}
                formatNumber={formatNumber}
                openConfirmModalForPromotions={openConfirmModalForPromotions}
                currentSortKey={filter2.sortBy}
                currentSortOrder={filter2.sortOrder}
                onSort={handleSort2}
              />
            )}
            {activeTab === "plan" && (
              <Plantable
                filter={filter3}
                setFilter={setFilter3}
                TableName="Plans"
                TableHeader={planTableHeader}
                TableData={planList}
                handleCreateBoostPlan={handleCreateBoostPlan}
                viewAction={handleAdsView}
                handleSearch={handlePlanSearch}
                handleStatus={handleStatusBoost}
                editAction={editAction}
                handleDelete={handleDelete}
                formatNumber={formatNumber}
                handleFilter={(Key, value) =>
                  setPlanFilter((prev) => ({ ...prev, [Key]: value }))
                }
                currentSortKey={filter3.sortBy}
                currentSortOrder={filter3.sortOrder}
                onSort={handleSort3}
              />
            )}
            {activeTab === "Advertisement" && (
              <AdvertisementTable
                handleFilter={handleAddsFilter}
                filter={filter4}
                setFilter={setFilter4}
                TableName={`Platform Wide Advertisement Promotions`}
                TableHeader={advertisementTableHeader}
                TableData={advertisements}
                viewAction={handleAdvertisementView}
                handlePageClick={handlePageClick4}
                total={advertisementTotal}
                handleSearch={handleSearch4}
                formatNumber={formatNumber}
                openConfirmModalForPromotions={openConfirmModalForPromotions}
                openCreateAdvertisementModal={(data = {}) =>
                  handleNewAdvertisementModal("open", data)
                }
                handleStatus={handleAdvertisementStatus}
                currentSortKey={filter4.sortBy}
                currentSortOrder={filter4.sortOrder}
                onSort={handleSort4}
              />
            )}
          </div>
        </div>
      </section>

      {/* Modals */}
      {isCreateAddModal && (
        <CreateAdsModal
          title={!inputsData?._id ? "Create New Banner" : "Update Banner"}
          inputData={inputsData}
          setInputsData={setInputsData}
          handleONChange={handleAdsCreateOnChnage}
          onCancel={toggleAdsCreateModal}
          onSubmit={submitCreateAds}
        />
      )}

      {isEditAdsmodal && (
        <EditAdsModal
          editAdsData={editAdsData}
          onCancel={toggleEditAdsData}
          handleONChange={handleAdsEditOnChange}
        />
      )}

      {isCreateBoostPlanModal && (
        <CreatePromoModal
          inputData={promoInputsData}
          handleONChange={handleCreatePromoCreateOnChange}
          onCancel={togglePromoCreateModal}
          onSubmit={handleBoostSubmit}
        />
      )}

      {isViewModal && (
        <ViewAds onClose={() => toggleModal("VIEW")} data={clickedData} />
      )}

      {isBannerViewModal && (
        <ViewBanner
          onClose={() => toggleModal("VIEW_BANNER")}
          data={clickedData}
        />
      )}

      {isAdvertisementViewModal && (
        <ViewAdvertisement
          onClose={() => toggleModal("VIEW_ADVERTISEMENT")}
          data={clickedData}
        />
      )}

      {isEditPlanModal && (
        <EditPlan
          onCancel={togglePlanEditModal}
          editPromoData={editPlanData}
          handleONChange={handlePlanEditChange}
          onSubmit={handleEditPlanSubmit}
        />
      )}

      {confirmModalState.isOpen && (
        <ConfirmToggleModal
          isOpen={confirmModalState.isOpen}
          status={confirmModalState.status}
          onConfirm={handleConfirmToggle}
          onCancel={closeConfirmModalForPromotions}
        />
      )}

      {newAdvertisement.isOpen && (
        <CreateNewAdvertisement
          isOpen={newAdvertisement.isOpen}
          onClose={() => handleNewAdvertisementModal("close")}
          data={newAdvertisement.data}
          setData={setNewAdvertisement}
          onSubmit={handleNewAdvertisementSubmission}
        />
      )}
    </div>
  );
};

export default AdsAndPromotation;